import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Image as ImageIcon, BookOpenIcon, GraduationCapIcon, MapIcon, UsersIcon } from 'lucide-react';
export function FeaturesDetail() {
  const features = [{
    icon: <ImageIcon className="w-7 h-7" data-id="element-101" />,
    title: <>
          Más de <strong data-id="element-102">280</strong> Imágenes en Alta Resolución
        </>,
    desc: 'Reconstrucciones 3D, mapas detallados y fotografías reales de los sitios bíblicos. Es como tener un guía arqueológico personal a tu lado.'
  }, {
    icon: <BookOpenIcon className="w-7 h-7" data-id="element-103" />,
    title: <>
          Cobertura Total: Los <strong data-id="element-104">66</strong> Libros
        </>,
    desc: <>
          Contexto visual de <strong data-id="element-105">CADA</strong> libro de la Biblia. Todo en
          un solo recurso.
        </>
  }, {
    icon: <GraduationCapIcon className="w-7 h-7" data-id="element-106" />,
    title: 'Profundidad Académica con Contexto Arqueológico',
    desc: 'Geografía física detallada, clima, vegetación y datos arqueológicos verificados.'
  }, {
    icon: <MapIcon className="w-7 h-7" data-id="element-107" />,
    title: 'Mapas Detallados por Período y Región',
    desc: <>
          Ver <strong data-id="element-108">EXACTAMENTE</strong> cómo se veía el territorio antes de
          leer cada pasaje.
        </>
  }, {
    icon: <UsersIcon className="w-7 h-7" data-id="element-109" />,
    title: 'Perfecto Para Principiantes y Estudiosos Avanzados',
    desc: <>
          Contenido para <strong data-id="element-110">TODOS</strong> los niveles de conocimiento
          bíblico.
        </>
  }];
  return <section className="py-14 bg-white" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <FadeIn className="text-center max-w-3xl mx-auto mb-10" data-id="element-113">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-navy-900 mb-3" data-id="element-114">
            ¿Qué Hace de Esta una Guía Visual "Perfecta"?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-115">
            Debe ser lo suficientemente detallada para no dejar{' '}
            <strong data-id="element-116">NADA</strong> a la imaginación, pero lo suficientemente
            clara para que cualquier creyente la disfrute.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-117">
          {features.map((feature, index) => <FadeIn key={index} delay={index * 0.08} className={`bg-cream rounded-xl p-5 border border-gray-100 ${index === 3 ? 'md:col-span-1 lg:col-start-2' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-118">
              <div className="w-12 h-12 rounded-lg bg-navy text-gold flex items-center justify-center mb-4 shadow-lg" data-id="element-119">
                {feature.icon}
              </div>
              <h3 className="text-lg font-bold text-navy-900 mb-2 leading-tight" data-id="element-120">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-121">
                {feature.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}